import type { useTransition } from '@react-spring/web';

import type { Dropdown } from '../Dropdown/types';

export const ARROW_ANIMATION_DURATION = 150;
export const DROPDOWN_ANIMATION_DURATION = 50;
export const CONTENT_ANIMATION_DURATION = 150;
export const CLOSE_MENU_DELAY = 300;

export type AnimationDirection = 'left' | 'right' | null;

export const getAnimationDirection = (
    dropdowns: Dropdown[],
    activeDropdownId: Dropdown['id'] | undefined,
    previousDropdownId: Dropdown['id'] | undefined,
): AnimationDirection => {
    if (!activeDropdownId || !previousDropdownId || activeDropdownId === previousDropdownId) {
        return null;
    }

    const currentDropdownIndex = dropdowns.findIndex(
        (dropdown) => dropdown.id === activeDropdownId,
    );
    const previousDropdownIndex = dropdowns.findIndex(
        (dropdown) => dropdown.id === previousDropdownId,
    );

    return currentDropdownIndex > previousDropdownIndex ? 'left' : 'right';
};

export const getContentTransitionConfig = (
    direction: AnimationDirection,
): Parameters<typeof useTransition>[1] => {
    if (direction === 'left') {
        return {
            from: { opacity: 0, left: -300 },
            enter: { opacity: 1, left: 0 },
            leave: { opacity: 0, left: 300 },
        };
    }

    if (direction === 'right') {
        return {
            from: { opacity: 0, left: 300 },
            enter: { opacity: 1, left: 0 },
            leave: { opacity: 0, left: -300 },
        };
    }

    return {};
};
